import Highcharts from 'highcharts';

export const figure44 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: 1000,
        marginLeft: 300,
        type: 'bar',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ffc000', '#ed7d31', '#4472c4', '#8faadc'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [
          "América del Norte y Europa",
          "Mundo",
          "América Latina y el Caribe",
          "África septentrional y Asia occidental",
          "África subsahariana",
          "Asia central y Asia meridional",
          "Pequeños Estados insulares en desarrollo",
          "Australia y Nueva Zelandia",
          "Asia oriental y Asia sudoriental",
          "Países menos adelantados",
          "Oceanía (excluidas Australia y Nueva Zelandia)",
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
  
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{ // Primary yAxis
        labels: {
          format: '{value}.0%',
          //format: '{value}',
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 2.0,
        min: 0.0,
        tickInterval: 0.5,
        gridLineWidth:2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2017',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [0.0290, 0.0914, 0.1096, 0.2528, 0.4611, 0.2197, 0.4958, 0.5461, 0.5742, 1.0582, 1.3386]
      },{
        name: '2015',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [0.0274, 0.0896, 0.0944, 0.2307, 0.4206, 0.2419, 0.5020, 0.5803, 0.6316, 1.1317, 1.5352]
      },{
        name: '2013',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [0.0295, 0.0900, 0.1211, 0.1764, 0.3152, 0.2493, 0.4953, 0.5592, 0.6255, 1.1136, 1.7472]
      },{
        name: '2011',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [0.0320, 0.0932, 0.1174, 0.1873, 0.2465, 0.2470, 0.4945, 0.5036, 0.7592, 1.1428, 1.5560]
      }]
  
};